import './WidgetSelector.css';

import { useState } from 'react';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';
import WidgetTemplateCard from './WidgetTemplateCard';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import useGettingAvailableWidgetTemplates from '../hooks/useGettingAvailableWidgetTemplates';
import { use_AREA_INDICATOR_eligibilityHelper } from '../hooks/use_AREA_INDICATOR_eligibilityHelper';
import { use_ORGANIZATION_eligibilityHelper } from '../hooks/use_ORGANIZATION_eligibilityHelper';

const WidgetSelector = ({ dto = null, scope = 'AREA_INDICATOR', selectedTemplate = null, onSelectWidgetTemplate = null }) => {

    const { t } = useB2BTranslation('b2b-reporting');
    const [page, setPage] = useState(1);

    const { availableWidgetTemplates } = useGettingAvailableWidgetTemplates(scope);
    const { getApplicableTemplates } = (scope === 'AREA_INDICATOR') ? use_AREA_INDICATOR_eligibilityHelper()
        : use_ORGANIZATION_eligibilityHelper();
    const applicableWidgetTemplates = getApplicableTemplates(
        availableWidgetTemplates || [],
        dto
    );

    const handleSelectedWidgetTemplate = (widgetTemplate) => {
        onSelectWidgetTemplate && onSelectWidgetTemplate(widgetTemplate);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    return (
        applicableWidgetTemplates && (
            <B2BElementsExplorerInMemory
                numRows={4}
                elementsData={{ content: applicableWidgetTemplates }}
                className='widget-config-selector'
                ElementComponent={WidgetTemplateCard}
                elementComponentPropName={'widgetTemplate'}
                otherComponentProps={{
                    selectedTemplate: selectedTemplate,
                }}                
                elementComponentHandlers={{
                    onSelect: handleSelectedWidgetTemplate
                }}
                currentPage={page}
                handlePageChange={handlePageChange}
            />
        )
    );
};

export default WidgetSelector;